import React from 'react'
import './Contact.css'

const Contact = () => {
    const [result, setResult] = React.useState("");

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending....");
        const formData = new FormData(event.target);

        formData.append("access_key", "a560c277-8185-43f5-9eee-f0fd0959130e");

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData
        });

        const data = await response.json();
        const message='Form Submitted Successfully';

        if (data.success) {
            setResult("Form Submitted Successfully");
            event.target.reset();
            setTimeout(() => {
                setResult("");
              }, 5000);
            
        } else {
            console.log("Error", data);
            setResult(data.message);
            setTimeout(() => {
                setResult("");
              }, 5000);
        }
    };
    return (
        <div id='contact' className='contact'>
            <div className="contact-title">
                <h1>Get in touch</h1>
                
            </div>
                <div className="contact-section">
                    <div className="contact-left">
                        <h1>Let's talk</h1>
                        <p>I'm currently available to take on new projects, so feel free about anything that you want me to work on. You can contact anytime.</p>
                        <div className="contact-details">
                            <div className="contact-detail">
                                 <p>programmerprashu@gmail.com</p>
                            </div>
                            {/* <div className="contact-detail">
                                 <p>+91 </p>
                            </div> */}
                            <div className="contact-detail">
                                 <p>UP India</p>
                            </div>
                        </div>
                    </div>
                    <form onSubmit={onSubmit} className='contact-right' action="">
                        <label htmlFor="">Your Name*</label>
                        <input type="text" placeholder='Enter Your Name' name='name' required/>
                        <label htmlFor="">Your Email*</label>
                        <input type="email" placeholder='Enter Your Email' name='email' required/>
                        <label htmlFor="">Write Your Message*</label>
                        <textarea name="message" id="" rows='4' placeholder='Enter Your Message' required></textarea>
                    {result && (
                        <div className="form-result" style={{ marginTop: "15px", fontWeight: "bold", color: result.includes("Success") ? "lightgreen" : "red" }}>
                            <span  className="close-btn" onClick={() => setResult("")}>×</span>
                            {result}
                        </div>
                    )}

                        <button type='submit' className='contact-submit'>Submit now</button>

                    </form>


            </div>

        </div>
    )
}

export default Contact
